import { useMemo } from 'react';
import { cloneTracker, cloneStandaloneTracker } from '../utils/UsageTracker';
export const NOT_USING_TRACKER = 'WE HAVE CUSTOM TRACKING IN PLACE AND AI-EXTENSIBILITY TEAM IS AWARE';
export const useTracker = (trackerInstance, usageTrackerLocation) => {
  const aiTracker = useMemo(() => {
    if (trackerInstance === NOT_USING_TRACKER) {
      return undefined;
    }
    return cloneStandaloneTracker(trackerInstance, usageTrackerLocation);
  }, [trackerInstance, usageTrackerLocation]);
  const legacyTracker = useMemo(() => {
    if (trackerInstance === NOT_USING_TRACKER) {
      return undefined;
    }
    return trackerInstance.clone({
      standalone: false,
      preserveTrackerProperties: false
    });
  }, [trackerInstance]);
  return {
    aiTracker,
    legacyTracker
  };
};

/** Prefer useTracker over making the tracker optional */
export const useOptionalTracker = (trackerInstance, appName) => {
  const aiTracker = useMemo(() => {
    if (trackerInstance === NOT_USING_TRACKER || !trackerInstance) {
      return undefined;
    }
    return cloneStandaloneTracker(trackerInstance, appName);
  }, [trackerInstance, appName]);
  const legacyTracker = useMemo(() => {
    if (trackerInstance === NOT_USING_TRACKER || !trackerInstance) {
      return undefined;
    }
    return cloneTracker(trackerInstance, appName);
  }, [trackerInstance, appName]);
  return {
    aiTracker,
    legacyTracker
  };
};